import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject } from '@angular/core';
import { ValidationProblem } from 'src/app/_utils/_validators/_models/validation-problem';
import { environment } from 'src/environments/environment';

export class BaseService
{

  /**
 * Url para las redirecciones
 */
  _urlPlatformSego: string;

  /**
   * Api con la ruta hasta el core.
   */
  _apiCoreUrl: string;

  /**
   * Api con la ruta hasta el core.
   */
  _apiCoreFullUrl: string;

  /**
   * Api con la ruta hasta venture.
   */
  _apiVentureUrl: string;

  /**
   * Api con la ruta hasta factoring.
   */
  _apiFactoringUrl: string;

  /**
   * Api con la ruta hasta factoring.
   */
  _apiFacturacionUrl: string;

  /**
   * Api de funds de segofinance.
   */
  _apiFunds: string;

  /**
   * Api con la ruta hasta real estate
   */
  _apiRealEstateUrl: string;


  /**
   * Api con la ruta hasta audiovisual 
   */
  _apiAudiovisual: string;

  /**
   * Api con la ruta hasta videojuegos 
   */
  _apiVideojuegos: string;

  /**
* Api con la ruta hasta webContent 
*/
  _apiWebContent: string;


  _http: HttpClient;

  _headers: HttpHeaders; //TODO: creo que no se usa
  /**
   * Indica en la linea de negocio en la que se encuentra el usuario (subdominio).
   */
  _domainEnvironment: DOMAIN_ENVIRONMENT;

  _document: Document;

  /**
   * Default generic constructor.
   * @param http HttpClient
   * @param genericRoute Nombre de la ruta
   * @param version "Ex: v1"
   */
  constructor(
    http: HttpClient, route: string, version: string)
  {
    this._http = http;
    this._headers = new HttpHeaders();
    this._headers.append('Content-Type', 'application/json');
    this._apiCoreUrl = environment.apiCore;
    this._apiVentureUrl = environment.apiVenture;
    this._apiRealEstateUrl = environment.apiRealEstate;
    this._apiFunds = environment.apiFunds;
    this._apiFactoringUrl = environment.apiFactoring;
    this._apiFacturacionUrl = environment.apiFacturacion;
    this._apiCoreFullUrl = `${this._apiCoreUrl}${version}/${route}`;
    this._urlPlatformSego = environment.urlPlatformSego;
    this._apiAudiovisual = environment.apiAudiovisual;
    this._apiVideojuegos = environment.apiVideojuegos;
    this._apiWebContent = environment.apiWebContent;
  }

  public getLocation()
  {
    return window.location.protocol + "//" + window.location.host;
  }

  public getServerErrors(error: HttpErrorResponse)
  {
    //TODO: esto es muy buena idea, pero debería estar más en la clase validationProblem y no en un service. A lo mejor en mismo constructor
    let errorMsg = "";
    switch (error.status)
    {
      case 400:
        errorMsg = this.getValidationProblem(error as ValidationProblem);
        break;
      case 401:
        errorMsg = "Sesión expirada. Inicia sesión nuevamente.";
        break;
      case 403:
        errorMsg = "Acceso denegado.";
        break;
      case 404:
        errorMsg = "Error de conexión con el servidor. Inténtelo más tarde.";
        break;
      case 405:
        errorMsg = "Operación no permitida. Contenido no disponible.";
        break;
      case 408:
        errorMsg = "Tiempo de espera agotado. Inténtalo de nuevo.";
        break;
      case 409:
        errorMsg = "Conflicto detectado. Inténtalo de nuevo más tarde.";
        break;
      case 500:
        errorMsg = "Error en el servidor. Inténtalo más tarde.";
        break;
      default:
        errorMsg = this.getValidationProblem(error as ValidationProblem);
        break;
    }
    return errorMsg;
  }

  private getValidationProblem(serverErrors: ValidationProblem)
  {
    let errorMsg = "";
    if (serverErrors.error.detail)
    {
      errorMsg = serverErrors.error.detail;
    } else
    {
      const errors = (<HttpErrorResponse>serverErrors).error.errors;
      for (let errorId in errors)
      {
        if (Object.hasOwnProperty.call(errors, errorId))
        {
          errorMsg += errors[errorId] + " ";
        }
      }
    }

    // Mensaje por defecto para que no salga vacío el snackbar si no vienen errores de la API
    if (errorMsg == "") { errorMsg = "El servicio no está disponible en este momento, por favor inténtalo en unos instantes."; }

    return errorMsg;
  }
}

export enum DOMAIN_ENVIRONMENT
{
  "SEGOFINANCE", "VENTURE", "REALESTATE", "FACTORING", "FUNDS", "CREATIVE"
}


export enum Environment { "development", "production", "testing" }

